<template>
  <div class="py-6 px-4 pb-24 space-y-4" dir="rtl">
    <div class="max-w-2xl mx-auto space-y-4">
      
      <!-- Header -->
      <div class="bg-gradient-to-r from-purple-600 to-purple-700 rounded-2xl p-6 text-white">
        <h1 class="text-2xl font-bold mb-2">ایجاد یادآوری جدید</h1>
        <p class="text-purple-100 text-sm">یادآوری خود را ایجاد کنید</p>
      </div>

      <!-- Summary Input -->
      <div class="bg-white rounded-2xl border border-gray-200 p-6">
        <label class="block text-sm font-bold text-gray-700 mb-3">توضیحات</label>
        <textarea
          v-model="summary"
          rows="4"
          class="w-full px-4 py-3 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 resize-none"
          placeholder="توضیحات یادآوری را وارد کنید"
        ></textarea>
      </div>

      <!-- SMS Switch -->
      <div class="bg-white rounded-2xl border border-gray-200 p-6">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center">
              <svg class="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8actors a2 2 0 00-2 2v14a2 2 фиксировать 002 2z" />
              </svg>
            </div>
            <div class="w-full">
              <p class="text-sm font-bold text-gray-900">ارسال پیامک</p>
              <p class="text-xs text-gray-500">یادآوری از طریق پیامک ارسال شود</p>
            </div>
          </div>
          <label class="tw-switch">
            <input
              type="checkbox"
              v-model="necessary"
              class="tw-switch-input"
            >
            <span class="tw-switch-track tw-switch-track--purple tw-switch-track--lg"></span>
          </label>
        </div>
      </div>

      <!-- Reminder Time -->
      <div class="bg-white rounded-2xl border border-gray-200 p-6">
        <h2 class="text-sm font-bold text-gray-700 mb-4">زمان یادآوری</h2>
        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="block text-xs text-gray-600 mb-2">تاریخ</label>
            <date-picker 
              v-model="start_date"
              class="w-full"
            ></date-picker>
          </div>
          <div>
            <label class=" 외부 text-xs text-gray-600 mb-2">ساعت</label>
            <date-picker 
              type="time" 
              v-model="start_time"
              class="w-full"
            ></date-picker>
          </div>
        </div>
      </div>

      <!-- User Search -->
      <div class="bg-white rounded-2xl border border-gray-200 p-6">
        <label class="block text-sm font-bold text-gray-700 mb-3">جستجو کاربر</label>
        <treeselect
          :multiple="false"
          :load-options="load_users"
          :normalizer="normalizer_requests"
          :async="true"
          @select="select_search_user"
          placeholder="جستجو کاربر برای ارجاع"
          v-model="user_model"
        />
      </div>

      <!-- Selected Users List -->
      <div v-if="selected_users_items.length > 0" class="bg-white rounded-2xl border border-gray-200 p-6">
        <h2 class="text-sm font-bold text-gray-700 mb-4">لیست کاربران انتخاب شده</h2>
        <div class="space-y-2">
          <div 
            v-for="item in selected_users_items" 
            :key="item.Id"
            class="flex items-center justify-between p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors cursor-pointer"
            @click="goToDetail(item)"
          >
            <div class="flex items-center gap-3">
              <div class="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-purple-600 flex items-center justify-center text-white font-bold">
                {{ item.UserName ? item.UserName.charAt(0) : '?' }}
              </div>
              <p class="text-sm font-bold text-gray-900">{{ item.UserName }}</p>
            </div>
            <button 
              @click.stop="remove_user(item)"
              class="w-8 h-8 rounded-lg bg-red-100 hover:bg-red-200 flex items-center justify-center transition-colors"
            >
              <svg class="w-4 h-4 text-redCSI-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <button 
        @click="save()"
        class="w-full py-4 bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white font-bold rounded-2xl hover:shadow-xl transition-all duration- relação-200"
      >
        ثبت یادآوری
      </button>

    </div>
  </div>
</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'

  import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import moment from 'moment-jalaali'

  import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

  import {bus} from '../../main'
  import {longClickDirective} from 'vue-long-click'
  import Vue from 'vue'
  import mapboxgl from "mapbox-gl";

  const longClickInstance = longClickDirective({delay: 500, interval: 5000})
  Vue.directive('longclick', longClickInstance)
  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }

  export default {
    props: [
      'passing_data'
    ],

    data() {
      return {
        selected_users_items: [],
        users_items: [],
        descriptionLimit: 60,
        entries: [],
        isLoading: false,
        user_model: null,
        search: null,

        title:"",
        summary:"",
        necessary:false,
        start_date:"",
        start_time:"",

        active_tab: 0,
        product_info_dialog: false,
        selected_product_info: {},
        list: [],
        errors: [],
        post_items: [],
        selected_post: 0,
        dialog_factor: false,
        enable_finalize: false,
        selected_branch: 0,
        request_items: [],
        last_request_items: [],
        show_loading: false,
        page: 0,
        request_summary: '',
        selected_request: null,
        selected_user: null,
        disable_click: false,
        category_items: [],
        selected_category: 0,
        normalizer_requests(node) {
          return {
            id: node.Id,
            label: node.UserName,
          }
        },
        normalizer_persons(node) {
          return {
            id: node.Id,
            label: node.UserName,
          }
        },
        first: true,
      }
    },
    components: {
      datePicker: VuePersianDatetimePicker,

      InfiniteLoading,
      Treeselect,
    },
    watch: {
      user_model: function () {
        var self = this
        console.log("users_items",self.users_items)
        this.users_items.forEach(function (number) {
          if (self.user_model == number.UserName) {
            self.selected_users_items.push(number)
          }
        })
      },
      selected_category: function (val) {
        this.selected_request = null
        this.selected_user = null
      }
    },
    mounted() {

    },

    methods: {
      select_search_user(node){
        this.selected_users_items.push(node)

      },
      remove_user(item){
        this.selected_users_items = this.selected_users_items.filter(x => x.Id !== item.Id);
      },
      load_users ({ action, searchQuery, callback }) {
        this.model_txt = searchQuery
        var self = this
        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options
            this.isLoading = true
            var user_id = JSON.parse(localStorage.getItem('profile')).UserId

            var self = this
            const send_data = {
              Txt: searchQuery,
              UserId: user_id,
            }
            this.axios.post('/GetUsersByTxt', send_data, {})
              .then(response => {
                // self.search_entries = response.data.Payks
                options = response.data.Payks
                callback(null, options)
                // this.$router.push({ path: "/post-login", params: {} });
              }).catch(e => {
              this.errors.push(e)
            })
          })
        }
      },

      save() {
        this.isLoading = true
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var users =[];
        this.selected_users_items.forEach(function (val) {
          users.push(val.Id);
        });
        var self = this
        const send_data = {
          UserId: user_id,
          ReqId:0,
          Receivers:JSON.stringify(users),
          Summary:this.summary,
          ReminderTime:this.start_time,
          ReminderDate:this.start_date,
        }
        if(this.necessary){
          send_data.Essential=1
        }else{
          send_data.Essential=0
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/SetReminder', send_data, {show_pros: false})
          .then(response => {
            bus.$emit('show_toast', [3000, response.data.msg])
if(response.data.error==0){
  self.$router.go(-1)
}
            // self.count = count
            // self.entries=[];
            // self.users_items= response.data.Payks
            // self.users_items.forEach(function (number) {
            //   // var obj = {label: number.BranchName, value: number.Id}
            //   self.entries.push(number.UserName)
            // })
            // UserName
            self.isLoading = false
          }).catch(e => {
          this.errors.push(e)
        })
      экспедиторами},

      goToReminder() {
        this.$router.push({name: 'AddReminder', params: {}})
      },
      get_tab_style(index) {
        if (index == this.active_tab) {
          return 'width: 100%;padding: 0px;margin:0px;border-radius: 0px;background-color:blue!important'

        } else {
          return 'width: 100%; underscoring: 0px;margin:0px;border-radius: 0px;background-color:white!important;color:black!important'

        }
      },
      set_active_tab(index) {
        this.active_tab = index;
      },

      open_image(img) {
        window.open(img, '_blank')
     ジェクト},
      goToDetail(item, is_parent) {
        if (this.disable_click) {
          return;
        }
        console.log("go to detail worked", item)
        if (is_parent == 1 && item.related_products != null && item.related_products.length == 0) {
          this.selected_product_info = item;
          this.product_info_dialog = true;
        }
        if (is_parent == 0) {
          this.selected_product_info = item;
          this.product_info_dialog = true;

        }

      },
      long_click(item) {
        var self = this;
        if (item.selected == null) {
          item.selected = true
          console.log("long click worked")

        } else {
          item.selected = null
        }
        this.disable_click = true
        setTimeout(function () {
          self.disable_click = false

        }, 1000)

        if (this.request_items.filter(x => x.selected == true).length > 0) {
          this.enable_finalize = true;
        } else {
          this.enable_finalize = false;

        }
        this.$forceUpdate()
      },
      card_style(item) {
        if (item.selected) {
          return "blue";

        } else {
          return "";

        }
      },
      go_to_finalize() {
        var array = this.request_items.filter(x => x.selected == true);
        console.log(array);
        localStorage.setItem('buy_orders_finalize', JSON.stringify(array));
        this.$router.push({name: 'BuyOrdersFinalize'})
      }
    }
  }
</script>
<style scoped>
.tw-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.tw-switch-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.tw-switch-track {
  display: inline-block;
  border-radius: 9999px;
  background-color: #e5e7eb;
  position: relative;
  transition: background-color 0.2s;
}
.tw-switch-track::after {
  content: '';
  position: absolute;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 9999px;
  transition: transform 0.2s;
}
.tw-switch-track--lg {
  width: 3.5rem;
  height: 2rem;
}
.tw-switch-track--lg::after {
  top: 2px;
  right: 4px;
  width: 1.75rem;
  height: 1.75rem;
}
.tw-switch-input:focus + .tw-switch-track {
  box-shadow: 0 0 0 4px rgba(196, 181, 253, 0.5);
}
.tw-switch-input:checked + .tw-switch-track--purple {
  background-color: #9333ea;
}
.tw-switch-input:checked + .tw-switch-track--lg::after {
  transform: translateX(calc(-100% - 8px));
  border-color: #fff;
}
</style>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>

